import i18next from '../../Translation/config';
import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';


const InfoGate = () => {
  return <div className="platesWidthKey">
    {i18next.language === 'en' && (
    <p>
      Gate Width - value entered in the "Width of gateway/gate" field
      The value entered in the "Gate Width" field results from the following conditions:
      <ul>
        <li>Self-Supporting Gate: (Gate Width + 100) - 120 for L = 2000mm</li>
        <li>Self-Supporting Gate: ((Gate Width + 100) - 180) / 2 for L = 4499mm</li>
        <li>Self-Supporting Gate: ((Gate Width + 100) - 240) / 3 for L = 5800mm</li>
        <li>Self-Supporting Gate: (Gate Width - 220) / 3 for L = 6499mm</li>
        <li>Self-Supporting Gate: (Gate Width - 300) / 4 for L = 7500mm</li>
        <li>Single-Leaf Gate (standard hinges): Gate Width - 235 for L = 2499 mm</li>
        <li>Single-Leaf Gate (180-degree hinges): Gate Width - 185 for L = 2499 mm</li>
        <li>Single-Leaf Gate (standard hinges): (Gate Width - 295) / 2 for L = 2499 mm</li>
        <li>Single-Leaf Gate (180-degree hinges): (Gate Width - 245) / 2 for L = 2999 mm</li>
        <li>Single-Leaf Gate (standard hinges): (Gate Width - 370) / 2 for L = 3000-3750 mm</li>
        <li>Single-Leaf Gate (180-degree hinges): (Gate Width - 330) / 2 for L = 3000-3750 mm</li>
        <li>Single-Leaf-Folding Gate (without mounting strip): (Gate Width - 460) / 2 </li>
        <li>Single-Leaf-Folding Gate (with mounting strip): (Gate Width - 540) / 2 </li>
        <li>KNS Folding Gate: (Gate Width - 660) / 4</li>
        <li>KNS Folding Gate (If one mounting strip): (Gate Width - 740) / 4</li>
        <li>KNS Folding Gate (If two mounting strips): (Gate Width - 820) / 4</li>
      </ul>
      For Non-symetrical gate there will be seperate value for left and right wing:
      <ul>
        <li>Non-symmetrical Gate (standard hinges): (Wing Width - 225) for wing L = 2499mm</li>
        <li>Non-symmetrical Gate (180-degree hinges): (Wing Width - 175) for wing L = 2499mm</li>
        <li>Non-symmetrical Gate (standard hinges): ((Wing Width - 305) / 2) for wing L = 2999mm</li>
        <li>Non-symmetrical Gate (180-degree hinges): ((Wing Width - 255) / 2 ) for wing L = 2999mm</li>
        <li>Non-symmetrical Gate (standard hinges): ((Wing Width - 320) / 2 ) for wing L = 3750mm</li>
        <li>Non-symmetrical Gate (180-degree hinges): ((Wing Width - 280) / 2 ) for wing L = 3750mm</li>
      </ul>
    </p>
    )}
    {i18next.language.includes('pl') && (
    <p>
      Światło - wartość wpisana w pole "Szerokość furtki/bramy"
      Wartość podana w polu "Szerokość pola" wynika z poniższych warunków:
      <ul>
        <li>Brama samonośna: (Światło + 100) - 120 do L = 2000mm</li>
        <li>Brama samonośna: ((Światło + 100) - 180) / 2 do L = 4499mm</li>
        <li>Brama samonośna: ((Światło + 100) - 240) / 3 do L = 5800mm</li>
        <li>Brama samonośna: (Światło - 220) / 3 do L = 6499mm</li>
        <li>Brama samonośna: (Światło - 300) / 4 do L = 7500mm</li>
        <li>Brama jednoskrzydłowa (zawiasy standardowe): Światło - 235 do L = 2499 mm</li>
        <li>Brama jednoskrzydłowa (zawias 180 stopni): Światło - 185 do L = 2499 mm</li>
        <li>Brama jednoskrzydłowa (zawiasy standardowe): (Światło - 295) / 2 od L = 2499 mm</li>
        <li>Brama jednoskrzydłowa (zawias 180 stopni): (Światło - 245) / 2 do L = 2999 mm</li>
        <li>Brama jednoskrzydłowa (zawiasy standardowe): (Światło - 370) / 2 L = 3000-3750 mm</li>
        <li>Brama jednoskrzydłowa (zawias 180 stopni): (Światło - 330) / 2 do L = 3000-3750 mm</li>
        <li>Brama łamana jednoskrzydłowa (bez listwy montażowej): (Światło - 460) / 2 </li>
        <li>Brama łamana jednoskrzydłowa (z listwą montażową): (Światło - 540) / 2 </li>
        <li>Brama łamana KNS: (Światło - 660) / 4</li>
        <li>Brama łamana KNS (Jeżeli jedna listwa montażowa): (Światło - 740) / 4</li>
        <li>Brama łamana KNS (Jeżeli dwie listwy montażowe): (Światło - 820) / 4</li>
        <li>Brama niesymetryczna (zawiasy standardowe): (Światło - 290) do L skrzydła 2499mm</li>
        <li>Brama niesymetryczna (zawias 180 stopni): (Światło - 190) do L skrzydła 2499mm</li>
        <li>Brama niesymetryczna (zawiasy standardowe): ((Światło - 370) / 2) do L skrzydła 2999mm</li>
        <li>Brama niesymetryczna (zawias 180 stopni): ((Światło - 270) / 2 ) do L skrzydła 2999mm</li>
        <li>Brama niesymetryczna (zawiasy standardowe): ((Światło - 400) / 2 ) do L skrzydła 3750mm</li>
        <li>Brama niesymetryczna (zawias 180 stopni): ((Światło - 320) / 2 ) do L skrzydła 3750mm</li>
      </ul>
      Dla bramy niesymetrycznej wartość będzie odpowiednio podzielona na lewe i prawe skrzydło:
      <ul>
        <li>Brama niesymetryczna (zawiasy standardowe): (Światło skrzydła - 225) do L skrzydła 2499mm</li>
        <li>Brama niesymetryczna (zawias 180 stopni): (Światło skrzydła - 175) do L skrzydła 2499mm</li>
        <li>Brama niesymetryczna (zawiasy standardowe): ((Światło skrzydła - 305) / 2) do L skrzydła 2999mm</li>
        <li>Brama niesymetryczna (zawias 180 stopni): ((Światło skrzydła - 255) / 2 ) do L skrzydła 2999mm</li>
        <li>Brama niesymetryczna (zawiasy standardowe): ((Światło skrzydła - 320) / 2 ) do L skrzydła 3750mm</li>
        <li>Brama niesymetryczna (zawias 180 stopni): ((Światło skrzydła - 280) / 2 ) do L skrzydła 3750mm</li>
      </ul>
    </p>
    )}
  </div>;
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  
  export default function InfoGatePopup() {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const { t } = useTranslation();
  
    return (
      <div>
        <Button 
            onClick={handleOpen}
            style={{ padding: "0.4rem 2rem", background:"#44AF69", color:"white", marginBottom: "10px", borderRadius: "25px" }}
        >{t('popupTitle')}
        </Button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <InfoGate />
          </Box>
        </Modal>
      </div>
    );
  }
